export default __webpack_public_path__ + "static/media/documentIcon.523001c4.svg";